module.exports = __webpack_public_path__ + "static/img/ico_cat.d4b974a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/ico_cat.png
// module id = 0ZOb
// module chunks = 0